import React from 'react';
import PropTypes from 'prop-types';
import UiFormControlLabel from 'ui-components/ui-form-control-label/UiFormControlLabel';
import UiCheckbox from 'ui-components/ui-checkbox/UiCheckbox';
import UiSlider from 'ui-components/ui-slider/UiSlider';
import { UiSwitch } from 'ui-components';
import { useTranslation } from 'react-i18next';

const Range = ({
  options,
  keyName,
  onSubFilterChange,
  toggler = 'checkbox',
}) => {
  const { t } = useTranslation();

  const handleSliderChange = (values) => {
    onSubFilterChange({
      keyName,
      min: +values[0],
      max: +values[1],
    });
  };

  const handleTogglerChange = (e) => {
    const { checked } = e.target;
    onSubFilterChange({
      keyName,
      active: checked,
      min: checked ? 0 : null,
      max: checked ? 100 : null,
    });
  };

  let togglerComponent = null;
  if (toggler === 'switch') {
    togglerComponent = (
      <UiSwitch
        name={keyName}
        checked={options?.active}
        onChange={(event) => handleTogglerChange(event)}
      />
    );
  } else if (toggler === 'checkbox') {
    togglerComponent = (
      <UiCheckbox
        name={keyName}
        checked={options?.active}
        onChange={(event) => handleTogglerChange(event)}
      />
    );
  }

  return (
    <div className='range-slider mb-10'>
      <UiFormControlLabel
        className='mr-0'
        label={t(options?.label)}
        control={togglerComponent}
      />
      <div className='flex center mr-13'>
        <div className='w-20'>{options?.max === null ? 100 : options?.max}</div>
        <UiSlider
          isRtl={true}
          onChange={(event, newValue) => handleSliderChange(newValue)}
          value={[
            options?.min === null ? 0 : options?.min,
            options?.max === null ? 100 : options?.max,
          ]}
          disabled={!options?.active}
          className='flex-1 ml-20 mr-10'
          size='small'
          disableSwap
          sx={{
            color: '#37AAAF',
          }}
        />
        <div className='w-20'>{options?.min === null ? 0 : options?.min}</div>
      </div>
    </div>
  );
};

Range.propTypes = {
  options: PropTypes.object,
  keyName: PropTypes.string,
  onSubFilterChange: PropTypes.func,
  toggler: PropTypes.string,
};

export default Range;
